export class Drawpoint {
    values: Datapoint[];
}

export class Datapoint {
    name: string;
    series: Series[];
    constructor(name, series) {
        this.name = name;
        this.series = series;
    }
}
export class Series {
    name: string;
    value: number;
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}

export class GraphObj {
    name: string;
    data: any;
    constructor(name, data) {
        this.name = name;
        this.data = data;
    }
}